import { render, staticRenderFns } from "./ATimeUnitField.vue?vue&type=template&id=39c2a1b8&"
import script from "./ATimeUnitField.vue?vue&type=script&lang=js&"
export * from "./ATimeUnitField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports